export default "__VITE_ASSET__BfJk3MLk__"